<template>
  <div class="puzzle__item box">
    <div
      class="c-puzzle-picture"
      :class="{ 'last': isLast }"
    />
  </div>
</template>

<script>
export default {
  name: 'PuzzleItem',

  props: {
    inGame: {
      type: Boolean,
      required: true,
    },
    illustration: {
      type: String,
      required: true,
    },
    isLast: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  display: inline-block;
  position: absolute;
  width: 25%;
  text-align: center;
  backface-visibility: hidden;

  @include aspect-ratio(1, 1);

  .c-puzzle-picture {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-repeat: no-repeat;
    background-size: 400%;
  }

  @at-root .in-game & {
    width: calc(100% / 4);

    .c-puzzle-picture {
      top: 1px;
      left: 1px;
      width: calc(100% - 2px);
      height: calc(100% - 2px);
    }
  }
}
</style>
